module.exports = __webpack_public_path__ + "b0a744b638a3fa472f9995a4f51329f3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/GT-Eesti-Display-Bold.ttf
// module id = 39
// module chunks = 0